import React, { useCallback, useEffect, useState } from 'react';
import { routes } from 'constants/config';
import { Spinner } from 'ui';
import PracticeQuestionInsights from 'components/insights/practice/PracticeQuestionInsights';
import request from 'utils/request_ajax';
import ModuleLoadFailure from './ModuleLoadFailure';

const PracticeInsights = ({ lessonId, currentGroupId }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const [data, setData] = useState([]);

  const fetchInsights = useCallback(
    (page, insights) => {
      request
        .get(
          routes.LESSON_OVERVIEW.PRACTICE_INSIGHTS(
            lessonId,
            currentGroupId,
            page,
          ),
        )
        .then(responseData => {
          insights = insights.concat(responseData.insights);
          if (page < responseData.totalPages) {
            fetchInsights(page + 1, insights);
          } else {
            setLoading(false);
            setError();
            setData(insights);
          }
        })
        .catch(e => {
          setError(e);
          setLoading(false);
        });
    },
    [lessonId, currentGroupId],
  );

  const runRequest = _ => {
    fetchInsights(1, []);
  };

  useEffect(runRequest, [fetchInsights]);

  if (error) {
    return <ModuleLoadFailure reload={runRequest} />;
  }

  if (loading) return <Spinner />;

  return (
    <div>
      {data.map(
        insight =>
          insight.hasCriteria && (
            <PracticeQuestionInsights
              key={insight.questionPrompt}
              data={insight}
            />
          ),
      )}
    </div>
  );
};

export default props => <PracticeInsights {...props} />;
